import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, GeoJSON } from "react-leaflet";
import "leaflet/dist/leaflet.css";

/**
 * ServiceAreaMap — interactive Leaflet map showing the highlighted
 * service-area counties for The Phoenix Fix.
 */
export default function ServiceAreaMap() {
  const [geo, setGeo] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch("/geo/service-area.geojson")
      .then((r) => r.json())
      .then((d) => { if (!cancelled) setGeo(d); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const style = () => ({
    fillColor: "#f59e0b",
    weight: 2,
    opacity: 1,
    color: "#1e3a8a",
    fillOpacity: 0.32,
  });

  const onEachFeature = (feature, layer) => {
    const name = feature.properties?.county_name || feature.properties?.NAME;
    if (name) {
      layer.bindTooltip(`${name} County`, {
        permanent: false,
        direction: "center",
        className: "pf-county-tooltip",
      });
    }
    layer.on({
      mouseover: (e) => {
        e.target.setStyle({ fillOpacity: 0.55, weight: 3 });
      },
      mouseout: (e) => {
        e.target.setStyle(style());
      },
    });
  };

  return (
    <div
      className="relative w-full rounded-2xl overflow-hidden border border-slate-200 shadow-sm"
      data-testid="footer-map-embed"
    >
      <MapContainer
        center={[33.95, -84.30]}
        zoom={9}
        scrollWheelZoom={false}
        style={{ height: 360, width: "100%" }}
        attributionControl={true}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {geo && (
          <GeoJSON data={geo} style={style} onEachFeature={onEachFeature} />
        )}
      </MapContainer>
    </div>
  );
}
